// Délégation d'événement (0 impact au chargement)
document.body.addEventListener('click', (event) => {
  const link = event.target.closest('.remove-item');
  if (!link) return;
  
  event.preventDefault();
  const urlToRemove = link.getAttribute('data-remove-url');
  const parentElement = link.closest('.line-item');
  
  fetch(urlToRemove, { method: 'POST', headers: { 'Content-Type': 'application/json' }})
    .then(response => { if (response.ok) parentElement.remove(); });
});